import React from 'react';
import clsx from 'clsx';
import HistoryOutlinedIcon from '@mui/icons-material/HistoryOutlined';
import { useTranslation } from 'react-i18next';

import Icon from '../../../../../icons/Icon';
import { getSessionData } from '../../utils/formatSessionDate';

import scss from './SessionCard.module.scss';

function SessionCard({ session, isActive, onSelect }) {
  const { i18n } = useTranslation();
  const handleClick = () => {
    onSelect(session);
  };
  const { email, date } = getSessionData(session, i18n.language);
  const title = session.message || session.name;

  return (
    <li className={scss.item}>
      <button type='button' className={clsx(scss.card, isActive && scss.cardActive)} onClick={handleClick}>
        <span className={scss.iconWrapper}>
          <Icon icon={HistoryOutlinedIcon} className={scss.icon} disableCommonColors currentColor />
        </span>
        <span className={scss.textContent}>
          <span className={scss.message}>{title}</span>

          <div className={scss.info}>
            {email ? <span className={scss.email}>{email}</span> : null}
            {date ? <span className={scss.date}>{date}</span> : null}
          </div>
        </span>
      </button>
    </li>
  );
}

export default SessionCard;
